"use client";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { useState } from "react";

export function QueryProvider({ children }: { children: React.ReactNode }) {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            staleTime: 5 * 60 * 1000, // 5 minutes
            gcTime: 10 * 60 * 1000, // 10 minutes - garbage collection time
            refetchOnWindowFocus: false,
            retry: (failureCount, error) => {
              // Don't retry on 4xx errors (client errors)
              if (
                error instanceof Error &&
                (error as Error & { status?: number }).status &&
                (error as Error & { status?: number }).status! >= 400 &&
                (error as Error & { status?: number }).status! < 500
              ) {
                return false;
              }
              // Retry up to 1 time for network errors
              return failureCount < 1;
            },
          },
          mutations: {
            retry: false, // Mutations should not retry by default
            onError: (error) => {
              // Global error handler for mutations
              console.error("Mutation error:", error);
              // Could integrate with error tracking service (e.g., Sentry)
            },
          },
        },
      })
  );

  return (
    <QueryClientProvider client={queryClient}>
      {children}
      {process.env.NODE_ENV === "development" &&
        process.env.NEXT_PUBLIC_SHOW_REACT_QUERY_DEVTOOLS && (
          <ReactQueryDevtools initialIsOpen={false} />
        )}
    </QueryClientProvider>
  );
}
